import {useCallback} from 'react';
import {useMutation} from 'react-query';

import {getPollStart, sendPollFinish} from 'client/common/utils/api-client/poll';

import {SurveySlug} from '../types';

export function usePollStart(slug: SurveySlug, params: Record<string, string>) {
    const {mutateAsync} = useMutation(getPollStart);

    return useCallback(async () => {
        return mutateAsync({slug, params});
    }, [mutateAsync, slug, params]);
}

export function usePollFinish(slug: SurveySlug, params: Record<string, string>) {
    const {mutateAsync} = useMutation(sendPollFinish);

    return useCallback(
        async (questionId: string, optionId: number) => {
            return mutateAsync({slug, questionId, options: [optionId], params});
        },
        [mutateAsync, slug, params]
    );
}
